<template>
  <svg class="button__border-decor button__border-decor--right" width="13" height="42" viewBox="0 0 13 42" xmlns="http://www.w3.org/2000/svg"> <path d="M0 42H7H9.4C11.3882 42 13 40.3882 13 38.4V7.32515C13 6.37037 12.3679 5.45469 11.2426 4.77956L5.03407 1.05442C3.90885 0.379288 2.38272 0 0.791426 0H0V1H0.791426C2.11751 1 3 1 4 1.5L10.5 5.5C11.4377 6.06261 12 6.5295 12 7.32515V38C12 39.6569 10.6569 41 9 41H7H0V42Z" /></svg>
</template>

<script>
export default {
  name: "MainButtonDecorRightSmall",
};
</script>